// dndUtils.js
export const toDataUrl = (b64) =>
  b64 ? (String(b64).startsWith("data:") ? b64 : `data:image/jpeg;base64,${b64}`) : "";

export const stripDataUrl = (dataUri = "") =>
  dataUri.startsWith("data:image")
    ? dataUri.replace(/^data:image\/[a-zA-Z0-9+.+-]+;base64,/, "")
    : dataUri || "";

// ID de cliente para ítems nuevos (estable durante la sesión)
export const makeClientId = () =>
  `${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;

/**
 * Devuelve una key estable usando extractores de ID.
 * - Ignora undefined, null y "" (vacío).
 * - Si existe item.__cid lo usa.
 * - Si no, cae a idx (último recurso).
 */
export const getStableKey = (item, idx, extractors = []) => {
  for (const fn of extractors) {
    const v = fn?.(item);
    if (v !== undefined && v !== null) {
      const s = String(v);
      if (s !== "") return s;
    }
  }
  if (item?.__cid !== undefined && item.__cid !== null && String(item.__cid) !== "") {
    return `cid-${item.__cid}`;
  }
  return `idx-${idx}`;
};

export const resolveParentIndex = (parentArr = [], item = {}, extractors = [], fallback) => {
  if (!Array.isArray(parentArr)) return -1;

  for (const getId of extractors) {
    const id = getId?.(item);
    if (id !== undefined && id !== null && String(id) !== "") {
      const idx = parentArr.findIndex((p) => {
        const pid = getId?.(p);
        return pid !== undefined && pid !== null && String(pid) !== "" && pid === id;
      });
      if (idx !== -1) return idx;
    }
  }
  if (typeof fallback === "function") {
    const idx = parentArr.findIndex((p) => fallback(p, item));
    if (idx !== -1) return idx;
  }
  return -1;
};
